import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Analytics } from '@recruitee/analytics';
import { I18nService } from '@recruitee/i18n';
import {
  DialogData,
  DialogRef,
  RtStatefulComponent,
  ThemeService,
} from '@recruitee/user-interface';

import { TutorialDialogModuleTranslations, TutorialTranslations } from './translations';
import { TutorialStep } from './tutorial-dialog.types';

type State = {
  activeStepIndex: number;
  steps: TutorialStep[];
};

@Component({
  selector: 'rt-tutorial-dialog',
  templateUrl: './tutorial-dialog.component.html',
  styleUrls: ['./tutorial-dialog.component.less'],
})
export class TutorialDialogComponent extends RtStatefulComponent<State> {
  public dialogBodyTranslations: any;

  constructor(
    public analytics: Analytics,
    private dialog: DialogRef,
    @Inject(DialogData) private data: { config: TutorialStep[]; analyticsContext: string },
    private themeService: ThemeService,
    private i18n: I18nService,
    private sanitizer: DomSanitizer,
    protected cdRef: ChangeDetectorRef,
    @Inject(TutorialTranslations)
    public translations: TutorialDialogModuleTranslations,
  ) {
    super(cdRef);
    this.createState({
      activeStepIndex: 0,
      steps: this.data.config,
    });

    const { dialogBody } = this.translations;

    this.dialogBodyTranslations = {
      continue: this.i18n.translate(dialogBody.continue),
      finish: this.i18n.translate(dialogBody.finish),
      learnMore: this.i18n.translate(dialogBody.learnMore),
      skip: this.i18n.translate(dialogBody.skip),
    };
  }

  public get stepsCount(): number {
    return this.state.steps && this.state.steps.length;
  }

  public get activeStep(): TutorialStep {
    return this.state.steps[this.state.activeStepIndex];
  }

  public get isLast(): boolean {
    return this.state.activeStepIndex === this.state.steps.length - 1;
  }

  public get imgUrl(): string {
    return (this.themeService.isHighDPI ? this.activeStep.imgUrl2x : this.activeStep.imgUrl)!;
  }

  public get youtubeUrl(): SafeResourceUrl | boolean {
    const url = `https://www.youtube.com/embed/${this.activeStep.youtubeVideoId}`;

    return (
      !!this.activeStep.youtubeVideoId &&
      // eslint-disable-next-line ban/ban
      this.sanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }

  public setStep(index: number): void {
    this.setState({ ...this.state, activeStepIndex: index });
  }

  public nextStep(): void {
    this.setState({ ...this.state, activeStepIndex: this.state.activeStepIndex + 1 });
  }

  public close(): void {
    this.dialog.close();
  }

  public trackFinishButton(): void {
    if (this.data.analyticsContext)
      this.analytics.track(`${this.data.analyticsContext} Tutorial_FinishButtonClick`);
  }

  public trackSkipButton(): void {
    if (this.data.analyticsContext)
      this.analytics.track(`${this.data.analyticsContext} Tutorial_SkipButtonClick`);
  }
}
